import React from 'react';
import { useSelector } from 'react-redux';

import DownNodes from './down-nodes';
import HighPacketLossNodes from './high-packet-loss-nodes';
import HighCpuAvgNodes from './high-cpu-avg-nodes';
import HighMemoryNodes from './high-memory-nodes';

const NodesInfo = () => {
  return (
    <div className="grid-chart">
      <DownNodes />
      <HighPacketLossNodes />
      <HighCpuAvgNodes />
      <HighMemoryNodes />
    </div>
  );
};

export default NodesInfo;
